// hami-settings.js — 哈密设置浮窗（照搬 profile-panel 结构）
// 内容：顶部哈密头像卡（哈密头像 + 「哈密」标题，不放用户信息）→ 两个设置行 → 子页。
// 数据：GET /api/hami/settings 拉当前值填按钮右侧；子页点选即 PUT 全量保存、成功后返回主页并刷新。

import toast from './toast.js';
import { registerPanel, openPanel, closePanel, isOpen } from './panel-manager.js';

var AUTO_CLEAN_OPTIONS = [
  { value: '7', label: '7天' },
  { value: '15', label: '15天' },
  { value: '30', label: '30天' },
  { value: 'never', label: '从不' }
];

var STYLE_OPTIONS = [
  { value: '商务', desc: '正式克制、条理清晰，多敬语与专业表达' },
  { value: '知性', desc: '理性温和、有书卷气，措辞准确' },
  { value: '幽默', desc: '轻松诙谐，适当玩梗调侃' },
  { value: '可爱', desc: '活泼软萌，多用语气词与表情' },
  { value: '傲娇', desc: '表面高冷嘴硬、实则热心' },
  { value: '文艺', desc: '有画面感与诗意，善用比喻' }
];

var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M4.5 12.5l5 5 10-11"/></svg>';

var _body = null;             // 浮窗正文容器
var _currentPage = 'main';    // 'main' | 'autoClean' | 'style'
var _settings = { auto_clean_days: '7', speaking_style: '知性' }; // 默认值，GET 失败时用

function _autoCleanLabel(v) {
  for (var i = 0; i < AUTO_CLEAN_OPTIONS.length; i++) {
    if (AUTO_CLEAN_OPTIONS[i].value === v) return AUTO_CLEAN_OPTIONS[i].label;
  }
  return '7天';
}

function _iconChevron() {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
}
function _iconClean() {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';
}
function _iconStyle() {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8 8 0 0 1-8 8H6.5L3.5 22.5V12a8 8 0 0 1 8-8h2a8 8 0 0 1 8 8z"/></svg>';
}

// 设置行：图标 · 标题 …… 当前值 ›（当前值在按钮最右侧，对齐 lumeet）
function _buildRow(iconHtml, label, value, onClick) {
  var li = document.createElement('li');
  li.className = 'profile-row';
  var ic = document.createElement('span');
  ic.className = 'profile-row-ic';
  ic.innerHTML = iconHtml;
  li.appendChild(ic);
  var lab = document.createElement('span');
  lab.className = 'profile-row-label';
  lab.textContent = label;
  li.appendChild(lab);
  var val = document.createElement('span');
  val.className = 'profile-row-value';
  val.textContent = value;
  li.appendChild(val);
  var arrow = document.createElement('span');
  arrow.className = 'profile-row-arrow';
  arrow.innerHTML = _iconChevron();
  li.appendChild(arrow);
  li.addEventListener('click', onClick);
  return li;
}

// 主页：哈密头像卡 + 两个设置行
function _renderMain(body) {
  _currentPage = 'main';
  body.innerHTML = '';

  var card = document.createElement('div');
  card.className = 'profile-card';

  var avatar = document.createElement('div');
  avatar.className = 'profile-avatar hami-avatar';
  avatar.textContent = '哈';
  card.appendChild(avatar);

  var name = document.createElement('div');
  name.className = 'profile-name';
  name.textContent = '哈密';
  card.appendChild(name);

  body.appendChild(card);

  var group = document.createElement('ul');
  group.className = 'profile-group';
  group.appendChild(_buildRow(_iconClean(), '自动清理聊天记录', _autoCleanLabel(_settings.auto_clean_days), function() {
    _renderOptions(body, AUTO_CLEAN_OPTIONS, _settings.auto_clean_days, 'autoClean', function(value) {
      _saveBoth({ auto_clean_days: value });
    });
  }));
  group.appendChild(_buildRow(_iconStyle(), '说话风格', _settings.speaking_style, function() {
    _renderOptions(body, STYLE_OPTIONS, _settings.speaking_style, 'style', function(value) {
      _saveBoth({ speaking_style: value });
    });
  }));
  body.appendChild(group);

  var spacer = document.createElement('div');
  spacer.style.height = '24px';
  body.appendChild(spacer);
}

// 子页：单选列表（选项名 + 可选说明），当前项打勾；点选即回调
function _renderOptions(body, options, currentValue, page, onPick) {
  _currentPage = page;
  body.innerHTML = '';

  var group = document.createElement('ul');
  group.className = 'profile-group';
  options.forEach(function(opt) {
    var li = document.createElement('li');
    li.className = 'profile-row hami-opt' + (opt.value === currentValue ? ' sel' : '');
    var info = document.createElement('div');
    info.className = 'hami-opt-info';
    var lab = document.createElement('div');
    lab.className = 'hami-opt-label';
    lab.textContent = opt.label || opt.value; // 无 label 时回退 value（说话风格 value 即显示名）
    info.appendChild(lab);
    if (opt.desc) {
      var d = document.createElement('div');
      d.className = 'hami-opt-desc';
      d.textContent = opt.desc;
      info.appendChild(d);
    }
    li.appendChild(info);
    var chk = document.createElement('span');
    chk.className = 'hami-opt-check';
    chk.innerHTML = CHECK_SVG;
    li.appendChild(chk);
    li.addEventListener('click', function() { onPick(opt.value); });
    group.appendChild(li);
  });
  body.appendChild(group);

  // 自动清理子页底部：立即清空全部聊天记录（两步确认）
  if (page === 'autoClean') body.appendChild(_buildClearButton());
}

// 立即清空聊天记录按钮：两步确认（第一下变红字提示，第二下执行）
function _buildClearButton() {
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'hami-clear-btn';
  btn.textContent = '立即清空聊天记录';
  btn.addEventListener('click', function() {
    if (!btn.classList.contains('armed')) {
      btn.classList.add('armed');
      btn.textContent = '再点一次确认清空';
      return;
    }
    btn.disabled = true;
    btn.textContent = '清空中…';
    fetch('/api/hami/clear', { method: 'POST', credentials: 'include' })
      .then(function(r) { return r.json().then(function(d) { return { status: r.status, data: d }; }); })
      .then(function(res) {
        if (res.status === 200 && res.data && res.data.ok) {
          toast('已清空 ' + (res.data.cleared || 0) + ' 条聊天记录');
          try { window.dispatchEvent(new CustomEvent('hami:chat-cleared')); } catch (e) { /* 忽略 */ }
        } else {
          throw new Error((res.data && res.data.error) || '清空失败');
        }
      })
      .catch(function(e) { toast('清空失败：' + (e.message || '请检查网络')); })
      .then(function() {
        if (btn.isConnected) {
          btn.disabled = false;
          btn.classList.remove('armed');
          btn.textContent = '立即清空聊天记录';
        }
      });
  });
  return btn;
}

// 全量保存两个字段（子页只改其一，PUT 全量覆盖）；成功后返回主页并刷新按钮右侧值
function _saveBoth(patch) {
  var payload = { auto_clean_days: _settings.auto_clean_days, speaking_style: _settings.speaking_style };
  if (patch) payload = Object.assign(payload, patch);

  fetch('/api/hami/settings', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload)
  }).then(function(r) {
    return r.json().then(function(data) { return { status: r.status, data: data }; });
  }).then(function(res) {
    if (res.status === 200 && res.data && res.data.ok) {
      _settings.auto_clean_days = res.data.auto_clean_days;
      _settings.speaking_style = res.data.speaking_style;
      toast('已保存');
      if (_body) _renderMain(_body);
    } else {
      throw new Error((res.data && res.data.error) || '保存失败');
    }
  }).catch(function(e) {
    // 保存失败：提示并留在子页，不改动当前显示
    toast('保存失败：' + (e.message || '请检查网络'));
  });
}

// 拉当前设置；失败用默认值（7天 / 知性）
function _loadSettings(done) {
  fetch('/api/hami/settings', { credentials: 'include' })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data && data.auto_clean_days) _settings.auto_clean_days = data.auto_clean_days;
      if (data && data.speaking_style) _settings.speaking_style = data.speaking_style;
    })
    .catch(function() { /* GET 失败用默认值 */ })
    .then(function() { if (done) done(); });
}

// 正文构建：只负责内容区，外壳/头部/遮罩由 manager 提供
function _buildBody(container, ctx) {
  container.innerHTML = '';
  var body = document.createElement('div');
  body.className = 'profile-body';
  container.appendChild(body);
  _body = body;
  _currentPage = 'main';
  _settings = { auto_clean_days: '7', speaking_style: '知性' };
  _renderMain(body);
  // 拉到最新值后刷新主页按钮右侧（仍停留在主页才刷，避免打断用户在子页的操作）
  _loadSettings(function() {
    if (_body === body && _currentPage === 'main') _renderMain(body);
  });
}

registerPanel('hamiSettings', {
  title: '哈密设置',
  buildBody: _buildBody,
  // 头部 < 按钮：子页 → 回主页；主页 → 关闭浮窗
  onBack: function() {
    if (_currentPage === 'main') {
      closePanel();
    } else if (_body) {
      _renderMain(_body);
    }
  },
  // 关闭时清内部引用
  onClose: function() {
    _body = null;
    _currentPage = 'main';
  }
});

export function openHamiSettings() {
  // 已打开则不再重复打开（避免把子页误重置回主页）
  if (isOpen('hamiSettings')) return;
  openPanel('hamiSettings');
}
